export class FileManagerService {
  convertToBase64Str({ file = null }) {
    return new Promise((resolve, reject) => {
      if (file === null) {
        reject("File is null or undefined.");
        return;
      }

      const reader = new FileReader();

      // Dosya başarıyla yüklendiğinde çalışır
      reader.onload = () => {
        const mimeType = file.type;

        // Base64 string oluştur
        const base64String = `data:${mimeType};base64,${
          reader.result.split(",")[1]
        }`;

        resolve(base64String); // Başarıyla döndür
      };

      // Hata oluşursa çalışır
      reader.onerror = () => {
        reject("Failed to read file.");
      };

      reader.readAsDataURL(file); // Dosyayı Base64 olarak oku
    });
  }

  convertToByteArray(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => resolve(new Uint8Array(reader.result));
      reader.onerror = (error) => reject(error);
    });
  }

  convertToByteArrayMultiple(files) {
    const promises = Array.from(files).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const uint8Array = new Uint8Array(reader.result);

          // Base64 encode
          let binary = "";
          uint8Array.forEach((b) => (binary += String.fromCharCode(b)));
          const base64 = btoa(binary);

          resolve({
            Content: base64, // Base64 string
            Name: file.name,
            ContentType: file.type,
          });
        };
        reader.onerror = (error) => reject(error);
      });
    });

    return Promise.all(promises);
  }

  saveBase64File({
    content = "",
    fileName = "file",
    fileExtension = "pdf",
    contentType = "application/octet-stream",
  }) {
    return new Promise((resolve, reject) => {
      try {
        // Base64 veriyi çöz
        const byteCharacters = atob(content);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        // Blob oluştur
        const blob = new Blob([byteArray], { type: contentType });

        // Dosyayı indirmek için URL oluştur
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${fileName}.${fileExtension}`; // Dosya adını ve uzantısını birleştir
        //link.download = `${fileName}`; // Dosya adını ve uzantısını birleştir
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        resolve(window.$t("File_Downloaded_Successfully"));
      } catch (error) {
        reject(window.$t("Failed_To_Save_File"));
      }
    });
  }
  downloadBase64File(base64, fileName, mimeType) {
    const link = document.createElement("a");
    link.href = `data:${mimeType};base64,${base64}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadAndOpenFile({
    content = "",
    fileName = "file",
    fileExtension = "pdf",
    contentType = "application/octet-stream",
  }) {
    // Dosya adını ve uzantısını birleştir
    const completeFileName = `${fileName}.${fileExtension}`;

    // Blob oluştur
    const blob = new Blob([content], { type: contentType });

    // Blob'dan URL oluştur
    const fileURL = URL.createObjectURL(blob);

    // Yeni sekmede aç
    const newWindow = window.open(fileURL, "_blank");

    // Eğer dosyanın adını indirme sırasında göstermek istiyorsanız:
    if (!newWindow) {
      console.error("Yeni sekme açılamadı. Tarayıcı engellemiş olabilir.");
    } else {
      // Tarayıcı destekliyorsa, dosya adını indirilebilir şekilde ayarla
      newWindow.onload = () => {
        const anchor = document.createElement("a");
        anchor.href = fileURL;
        anchor.download = completeFileName;
        anchor.click();
      };
    }

    // (Opsiyonel) URL'yi serbest bırak
    setTimeout(() => {
      URL.revokeObjectURL(fileURL);
    }, 10000); // 10 saniye sonra URL'yi temizle
  }

  openBase64File({
    base64Content = "",
    fileName = "",
    contentType = "application/octet-stream",
  }) {
    try {
      // Base64 içeriği çöz
      const binary = atob(base64Content);
      const binaryArray = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        binaryArray[i] = binary.charCodeAt(i);
      }

      // Blob oluştur
      const blob = new Blob([binaryArray], { type: contentType });

      // Blob'dan URL oluştur
      const fileURL = URL.createObjectURL(blob);

      // Yeni sekmeyi aç
      const newWindow = window.open();
      if (!newWindow) {
        console.error("Yeni sekme açılamadı. Tarayıcı engellemiş olabilir.");
        return;
      }

      // Yeni sekmeye içerik yerleştir
      newWindow.document.write(`
        <html>
          <head>
            <title>${fileName}</title>
          </head>
          <body>
            <iframe src="${fileURL}" style="width: 100%; height: 100%;" frameborder="0"></iframe>
          </body>
        </html>
      `);

      // URL'yi serbest bırakmak için bir süre sonra temizleyelim
      setTimeout(() => {
        URL.revokeObjectURL(fileURL);
      }, 10000); // 10 saniye sonra URL'yi temizle
    } catch (error) {
      console.error("Dosya gösterilirken bir hata oluştu:", error);
    }
  }
}
